export default {
  '0073291313722': {
    upc: '0073291313722',
    name: 'Seventh Generation Recycled Paper Towels',
    slug: '0073291313722',
    priceCents: 1083,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0073291313722',
    brand: 'Seventh Generation',
    inStock: true,
    categories: ['Cleaning Products', 'Natural & Organic'],
  },
  '0001111071907': {
    upc: '0001111071907',
    name: 'Simple Truth Organic™ Original Instant Oatmeal',
    slug: '0001111071907',
    priceCents: 339,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0001111071907',
    brand: 'Simple Truth Organic',
    inStock: true,
    categories: ['Breakfast'],
  },
  '0001111002422': {
    upc: '0001111002422',
    name: 'Simple Truth Organic™ Original Instant Oatmeal Natural Maple & Brown Sugar',
    slug: '0001111002422',
    priceCents: 339,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0001111002422',
    brand: 'Simple Truth Organic',
    inStock: true,
    categories: ['Breakfast'],
  },
  '0001111080111': {
    upc: '0001111080111',
    name: 'Simple Truth Organic™ Strawberry Fruit and Grain Bars 6 Count',
    slug: '0001111080111',
    priceCents: 229,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0001111080111',
    brand: 'Simple Truth Organic',
    inStock: true,
    categories: ['Breakfast'],
  },
  '0005210008173': {
    upc: '0005210008173',
    name: 'McCormick Mediterranean Sea Salt Grinder',
    slug: '0005210008173',
    priceCents: 1016,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0005210008173',
    brand: 'McCormick',
    inStock: true,
    categories: ['Baking Goods'],
  },
  '0002460001085': {
    upc: '0002460001085',
    name: 'Morton All Purpose  Natural Sea Salt',
    slug: '0002460001085',
    priceCents: 321,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0002460001085',
    brand: 'Morton',
    inStock: true,
    categories: ['Baking Goods'],
  },
  '0001111001054': {
    upc: '0001111001054',
    name: 'Kroger® Pure Ground Black Pepper',
    slug: '0001111001054',
    priceCents: 654,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0001111001054',
    brand: 'Kroger',
    inStock: true,
    categories: ['Baking Goods'],
  },
  '0001111001119': {
    upc: '0001111001119',
    name: 'Simple Truth® Organic Unfiltered Extra Virgin Olive Oil',
    slug: '0001111001119',
    priceCents: 699,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0001111001119',
    brand: 'Simple Truth Organic',
    inStock: true,
    categories: ['Natural & Organic', 'Baking Goods'],
  },
  '0001111079153': {
    upc: '0001111079153',
    name: 'Simple Truth Organic™ Creamy Peanut Butter',
    slug: '0001111079153',
    priceCents: 382,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0001111079153',
    brand: 'Simple Truth Organic',
    inStock: true,
    categories: ['Natural & Organic', 'Condiment & Sauces'],
  },
  '0005165109218': {
    upc: '0005165109218',
    name: 'MaraNatha Creamy Raw California Almond Butter',
    slug: '0005165109218',
    priceCents: 1151,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0005165109218',
    brand: 'MaraNatha',
    inStock: true,
    categories: ['Natural & Organic', 'Condiment & Sauces'],
  },
  '0009955508520': {
    upc: '0009955508520',
    name: 'Green Mountain Breakfast Blend Light Roast Coffee K-Cup Pods 12 Count',
    slug: '0009955508520',
    priceCents: 504,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0009955508520',
    brand: 'Green Mountain',
    inStock: true,
    categories: ['Beverages'],
  },
  '0001111085405': {
    upc: '0001111085405',
    name: 'Private Selection™ Signature Blend large Coffee K-Cup Pods',
    slug: '0001111085405',
    priceCents: 602,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0001111085405',
    brand: 'Private Selection',
    inStock: true,
    categories: ['Beverages'],
  },
  '0001370084466': {
    upc: '0001370084466',
    name: 'Hefty Storage Slider Gallon Bags Mega Pack 66 Count',
    slug: '0001370084466',
    priceCents: 780,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0001370084466',
    brand: 'Hefty',
    inStock: true,
    categories: ['Cleaning Products'],
  },
  '0001370084274': {
    upc: '0001370084274',
    name: 'Hefty Freezer Quart Slider Bags Mega Pack',
    slug: '0001370084274',
    priceCents: 817,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0001370084274',
    brand: 'Hefty',
    inStock: true,
    categories: ['Cleaning Products'],
  },
  '0004122642276': {
    upc: '0004122642276',
    name: 'Dash of That™ Peeler',
    slug: '0004122642276',
    priceCents: 799,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0004122642276',
    brand: 'Dash of That',
    inStock: true,
    categories: ['Kitchen'],
  },
  '0004122642285': {
    upc: '0004122642285',
    name: 'Dash of That™ Locking Tongs - Silver',
    slug: '0004122642285',
    priceCents: 799,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0004122642285',
    brand: 'Dash of That',
    inStock: true,
    categories: ['Kitchen'],
  },
  '0004122642272': {
    upc: '0004122642272',
    name: 'Dash of That™ Stainless Steel Measuring Cup Set - Silver',
    slug: '0004122642272',
    priceCents: 1299,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0004122642272',
    brand: 'Dash of That',
    inStock: true,
    categories: ['Kitchen'],
  },
  '0004122642286': {
    upc: '0004122642286',
    name: 'Dash of That™ Locking Tongs - Silver',
    slug: '0004122642286',
    priceCents: 1299,
    imageUrl: 'https://www.kroger.com/product/images/large/front/0004122642286',
    brand: 'Dash of That',
    inStock: true,
    categories: ['Kitchen'],
  },
};
